import { createPortalServiceClient, PortalServiceLinkDto } from '@nimbus/portal-service';
import { generalEnv } from '@nx-frontend/shared/env';

export async function setLinks(props: { orgId: string }): Promise<PortalServiceLinkDto[]> {
  const portalServiceClient = createPortalServiceClient({
    basePath: generalEnv.portalServiceUrl + '/v1',
    secret: generalEnv.secret,
    superSecret: generalEnv.superSecret,
  });
  const result = await portalServiceClient.LinksApi.postLinksOrg(props, { superUser: true });
  return result.data;
}
